
















































































import { Component, Vue, Prop, PropSync, Watch, InjectReactive } from 'vue-property-decorator';
import { GQL_WorkRelationEmployeeSave } from '@/queries/global';
import { generateUID, WithUID } from '@/utils/utils';
import WorkRelationForm from './WorkRelationForm.vue';
import PermissionService from '@/utils/permission-service';
import { SmartQuery } from 'vue-apollo-decorator';
import { EMPLOYEE_FORM_UNIT_SETTINGS } from '@/queries/Employee';
import { GQL_employeeFormUnitSettings, GQL_employeeFormUnitSettings_currentUnit_unitSetting_unitPaycheckSetting } from '@/queries/__generated__/employeeFormUnitSettings';
import { buildNewWorkRelation } from '@/app/Employee';

@Component({
  components: {
    WorkRelationForm,
  },
})
export default class WorkRelationsTableForm extends Vue {
  @Prop({ type: Array, required: true }) private workRelations!: WithUID<GQL_WorkRelationEmployeeSave>[];
  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;

  @SmartQuery<WorkRelationsTableForm, GQL_employeeFormUnitSettings>({
    query: EMPLOYEE_FORM_UNIT_SETTINGS,
    update: data => data.currentUnit.unitSetting.unitPaycheckSetting,
  }) public unitPaycheckSetting!: GQL_employeeFormUnitSettings_currentUnit_unitSetting_unitPaycheckSetting;

  @InjectReactive() private editable!: boolean;

  private validWorkRelationForms: { [uid: string]: boolean } = {};
  private PermissionService = PermissionService;

  private get notDeletedWorkRelations(): WithUID<GQL_WorkRelationEmployeeSave>[] {
    return this.workRelations.filter(workRelation => !workRelation._destroy);
  }

  @Watch('workRelations', { immediate: true })
  private ensureUIDsAreSet(): void {
    this.workRelations.forEach(workRelation => {
      if (!workRelation.$_UID) {
        workRelation.$_UID = generateUID();
        Vue.set(this.validWorkRelationForms, workRelation.$_UID, true);
      }
    });
  }

  private addWorkRelation(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newWorkRelation: any = buildNewWorkRelation(this.unitPaycheckSetting);
    newWorkRelation.$_UID = generateUID();
    this.workRelations.push(newWorkRelation as WithUID<GQL_WorkRelationEmployeeSave>);
  }

  private removeWorkRelation(workRelation: WithUID<GQL_WorkRelationEmployeeSave>): void {
    if (workRelation.id) {
      Vue.set(workRelation, '_destroy', true);
    } else {
      this.workRelations.splice(
        this.workRelations.indexOf(workRelation),
        1,
      );
    }
  }

  private expandedInitialState(workRelation: WithUID<GQL_WorkRelationEmployeeSave>): boolean {
    if (!workRelation.id) return true;
    if (this.workRelations.length === 1) return true;
    if (workRelation.employmentType === "pensjonOgAndreTyperYtelserUtenAnsettelsesforhold") return false;
    if (!workRelation.endDate) return true;
    if (this.$dayjs.strict(workRelation.endDate).isSameOrAfter(this.$dayjs())) return true;

    return false;
  }

  @Watch('workRelations')
  @Watch('validWorkRelationForms', { deep: true })
  private setValidFormSync(): void {
    this.validFormSync = this.notDeletedWorkRelations.every(workRelation => this.validWorkRelationForms[workRelation.$_UID]);
  }
}
